export default {
	state: {
        bill:{}
	},
	mutations: {
		setBill(state, data) {
			state.bill = data;
		},
	},
	getters: {
	},
	actions: {
		
	}
}